import React, { useState } from 'react';

import ClinicalTab from './ClinicalTab';
import OldBloodTestsMembershipTab from './OldBloodTestsMembershipTab';
import OperationsTatDashboardTab from './OperationsTatDashboardTab';
import './ClinicalDashboard.scss';

type ClinicalDashboardTab = 'clinical' | 'old-blood-tests' | 'operations-tat';

const CLINICAL_DASHBOARD_TABS: { id: ClinicalDashboardTab; label: string }[] = [
  { id: 'clinical', label: 'Clinical' },
  { id: 'old-blood-tests', label: 'Old Blood Tests for membership' },
  { id: 'operations-tat', label: 'Operations / TAT dashboard' },
];

const ClinicalDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ClinicalDashboardTab>('clinical');

  return (
    <div className='page-container clinical-dashboard-page'>
      <div className='clinical-dashboard-tabs sideBarPad'>
        {CLINICAL_DASHBOARD_TABS.map((tab) => (
          <button
            key={tab.id}
            type='button'
            className={`clinical-dashboard-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'clinical' && <ClinicalTab />}
      {activeTab === 'old-blood-tests' && <OldBloodTestsMembershipTab />}
      {activeTab === 'operations-tat' && <OperationsTatDashboardTab />}
    </div>
  );
};

export default ClinicalDashboard;
